/**
 * Connection Manager Services - All API Service Exports
 * Migrated from 3in1CMS to bfl-web-apps monorepo
 *
 * Total Services: 42
 * - Core Services: 4 (api, cart, sso, user)
 * - Loan Insert Services: 15
 * - Financial Services: 4
 * - Consent Services: 2
 * - Integration Services: 7
 * - Read/CD Services: 4
 * - Complex Services: 6
 */

// ============================================================================
// CORE SERVICES (4)
// ============================================================================
export * from "../core/request";
export * from "./cart.service";
export * from "./sso.service";
export * from "./user.service";

// ============================================================================
// USER & PROFILE SERVICES (2)
// ============================================================================
export * from "./user.api.service";
export * from "./relationship.service";

// ============================================================================
// LOAN INSERT SERVICES (15)
// ============================================================================
export * from "./hlInsert.service"; // Home Loan
export * from "./glInsert.service"; // Gold Loan
export * from "./blInsert.service"; // Business Loan
export * from "./blseInsert.service"; // Business Loan SME
export * from "./profLoanInsert.service"; // Professional Loan
export * from "./nclInsert.service"; // New Car Loan
export * from "./solarInsert.service"; // Solar Loan
export * from "./solarRead.service"; // Solar Read
export * from "./solarMaster.service"; // Solar Master
export * from "./ucfInsert.service"; // Used Car Finance
export * from "./mefInsert.service"; // Medical Equipment Finance
export * from "./twfInsert.service"; // Two Wheeler Finance
export * from "./cvInsert.service"; // Commercial Vehicle (NCV/LCV/CVBT/UCV)
export * from "./lapInsert.service"; // Loan Against Property
export * from "./mflInsert.service"; // Mortgage Finance Loan
export * from "./utlInsert.service"; // Used Truck Loan
export * from "./salplInsert.service"; // Salaried Personal Loan
export * from "./insertUtils"; // Salaried Personal Loan Helpers
export * from "./plcsInsert.service"; // Personal Loan Cross Sell
export * from "./loans.service"; // Generic Loans
export * from "./icors.service"; // ICORS Offers
export * from "./recentsearch.service"; // Recent Search

// ============================================================================
// FINANCIAL SERVICES (4)
// ============================================================================
export * from "./fd.service"; // Fixed Deposit
export * from "./loanRewards.service"; // Loan Rewards
export * from "./bestEMICard.service"; // Best EMI Card
export * from "./emiCard.service"; // EMI Card

// ============================================================================
// CONSENT SERVICES (2)
// ============================================================================
export * from "./consentInsert.service";
export * from "./consentRead.service";

// ============================================================================
// INTEGRATION SERVICES (7)
// ============================================================================
export * from "./crossSellB2C.service"; // Cross-sell B2C
export * from "./redBus.service"; // RedBus Integration
export * from "./storesFromMMI.service"; // MMI Stores
export * from "./mapMyIndia.service"; // MMI branch mapping
export * from "./qrCdInsert.service"; // QR CD Insert
export * from "./qr.service"; // QR Services
export * from "./gameZone.service"; // Game Zone
export * from "./demog.service"; // Demographics

// ============================================================================
// READ & CD SERVICES (4)
// ============================================================================
export * from "./readMyOrder.service"; // Read My Order
export * from "./cdRead.service"; // CD Read
export * from "./cdInsert.service"; // CD Insert
export * from "./loanDetails.service"; // Loan Details

// ============================================================================
// COMPLEX SERVICES (6)
// ============================================================================
export * from "./loanSummary.service"; // Loan Summary
export * from "./glCalculator.service"; // Gold Loan Calculator
export * from "./cpr.service"; // Customer Payment Request

// ============================================================================
// CONSTANTS & TYPES
// ============================================================================
export * from "./constants";
